import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import useCRMStore from './store/useCRMStore'
import { setSessionExpiredHandler } from './services/api'
import Login from './components/auth/Login'
import ProtectedRoute from './components/auth/ProtectedRoute'
import SessionExpiredModal from './components/auth/SessionExpiredModal'
import Dashboard from './components/dashboard/Dashboard'
import useThemeStore from './store/useThemeStore'

function App() {
  useThemeStore()
  const { isAuthenticated } = useAuth()
  const sessionExpired = useCRMStore(state => state.sessionExpired)
  const setSessionExpired = useCRMStore(state => state.setSessionExpired)

  // Configurar el handler de sesion expirada al montar
  useEffect(() => {
    setSessionExpiredHandler(() => {
      setSessionExpired()
    })
  }, [setSessionExpired])

  return (
    <BrowserRouter basename="/crm-web">
      {/* Modal de sesion expirada - se muestra sobre todo */}
      {sessionExpired && <SessionExpiredModal />}

      <Routes>
        {/* Redirect root to dashboard or login */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Login route */}
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login />
            )
          }
        />

        {/* Protected dashboard route */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Catch all - redirect to root */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
